import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';
import type { WarningPattern } from './warningPatternQueries';

export interface CreateWarningPatternRequest {
  name?: string | null;
  surname?: string | null;
  email?: string | null;
  type: boolean; // true = exact match, false = partial match
}

export interface UpdateWarningPatternRequest {
  id: number;
  name?: string | null;
  surname?: string | null;
  email?: string | null;
  type: boolean;
}

export const createWarningPatternMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.warningPatterns.create(),
    mutationFn: async (values: CreateWarningPatternRequest) => {
      return await api
        .post('admin/warning-patterns', { json: values })
        .json<WarningPattern>();
    },
    onSuccess: () => {
      toast.success('Warning pattern created successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to create warning pattern');
    },
  });
};

export const updateWarningPatternMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.warningPatterns.update(),
    mutationFn: async ({ id, ...data }: UpdateWarningPatternRequest) => {
      return await api
        .put(`admin/warning-patterns/${id}`, { json: data })
        .json<WarningPattern>();
    },
    onSuccess: () => {
      toast.success('Warning pattern updated successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to update warning pattern');
    },
  });
};

export const deleteWarningPatternMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.warningPatterns.delete(),
    mutationFn: async (id: number) => {
      return await api.delete(`admin/warning-patterns/${id}`).json<void>();
    },
    onSuccess: () => {
      toast.success('Warning pattern removed successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to remove warning pattern');
    },
  });
};
